import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || '/api';
const auth = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export interface MandatoDaPlataforma {
  id: string;
  nome: string;
  nome_parlamentar: string | null;
  cargo: string;
  partido: string | null;
  cidade: string;
  uf: string;
  plano: string;
  modulos: string[];
  usuarios: number;
  created_at: string;
}

export interface NovoMandato {
  nome: string;
  cargo: string;
  cidade: string;
  uf: string;
  plano?: string;
  modulos?: string[];
  nome_titular: string;
  email_titular: string;
  senha_titular: string;
}

/**
 * Console do operador. Sessão separada da sessão de mandato, de propósito: o
 * token daqui não tem `tenantId` e é recusado nas rotas de gabinete, e o token
 * de gabinete é recusado aqui -- ver `plataforma/sessao-de-operador.ts` na API.
 */
export const plataformaApi = {
  async login(email: string, senha: string) {
    const { data } = await axios.post<{
      operador: { id: string; nome: string; email: string };
      token: string;
    }>(`${API_URL}/plataforma/auth/login`, { email, senha });
    return data;
  },

  async listarMandatos(token: string) {
    const { data } = await axios.get<MandatoDaPlataforma[]>(
      `${API_URL}/plataforma/mandatos`,
      auth(token),
    );
    return data;
  },

  async criarMandato(token: string, dados: NovoMandato) {
    const { data } = await axios.post<{ id: string }>(
      `${API_URL}/plataforma/mandatos`,
      dados,
      auth(token),
    );
    return data;
  },
};
